import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNotesMedical } from '@fortawesome/free-solid-svg-icons';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CircularProgress from '@mui/material/CircularProgress';

import AlertDetailsModal from './modals/alertdetailsmodal';
import FullScreenLabDetailsModal from './modals/fulscreenlabmodal';

import { useState } from 'react';
import api from '../../api/api';
import FileViewerModal from './modals/FileViewrModal';
import SummaryModal from './modals/summarymodal';
import { clinical, share } from './utils/svg';
import hubApi from 'api/hubapi';
import PortalLabModalWrapper from './portallabmodalwrapper';
import ClinicalShareModal from './modals/expandmodals/clinicalsharemodal';

const ClinicalIntelligence = ({ data, view }) => {
  const patient_insights = data;
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [label, setLabel] = useState('');
  const [openSummaryModal, setOpenSummaryModal] = useState(false);
  const [summaryHtml, setSummaryHtml] = useState('');

const[imageModalOpen, setImageModalOpen] = useState(false);
const[imagedata, setImageData] = useState(null);
const [labsModal,setLabsModal] = useState(false);
const [labsData,setLabsData] = useState(null);
const [loadingDetails, setLoadingDetails] = useState(false);
const [shareModalOpen, setShareModalOpen] = useState(false);
  const handleSummaryOpen = async (row) => {
    try {
      setSummaryHtml('');
setLoadingDetails(true)

      const sourceNode = row?.source_node_id?.[0];
      if (!sourceNode) throw new Error('Missing source_node_id');

      const parsed = JSON.parse(sourceNode);
      const { url, http_method, payload } = parsed;
      const relativeUrl = url.replace(/^https:\/\/[^/]+\/ag/, '');

      let response;
      if (http_method?.toLowerCase() === 'post') {
        response = await hubApi.post(relativeUrl, JSON.parse(payload));
      } else {
        response = await hubApi.get(relativeUrl);
      }

if (response && typeof response === 'object' && 'files' in response) {
  setImageData(response);
  setImageModalOpen(true);
} else if (
  response &&
  typeof response === 'object' &&
  'data' in response &&
  typeof response.data === 'object' &&
  response.data !== null &&
  'dates' in response.data
) {
  console.log(response.data, 'labs data received');
  setLabsData(response.data || []);
  setLabsModal(true);
} else if (
  response &&
  typeof response === 'object' &&
  'data' in response &&
  typeof response.data === 'object' &&
  response.data !== null &&
  'summaryhtml' in response.data
) {
  setSummaryHtml(response.data || []);
  setOpenSummaryModal(true);
} else {
  console.warn("Unexpected response format:", response);
}



    } catch (error) {
      console.error('Error loading summary:', error);
      setSummaryHtml([]);
    } finally {
   setLoadingDetails(false)
    }
  };

 

  return (
 <div className="h-full w-full flex flex-col">

<div
  className="bg-white text-xs text-start h-full"
  style={{
    borderRadius: '8.75px',
    boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)',
  }}
>


   <div className="flex justify-between items-center px-3 py-2 rounded-t-md">
             {/* Left Side: Icon + Label + Issues */}
             <div className="flex items-center gap-2 text-[#2C5282] font-semibold text-lg">
               {clinical}
               <span>Clinical Intelligence</span>
               
             
             </div>
           
             {/* Right Side: Share Icon */}
       {view!==1&& <div onClick={() => setShareModalOpen(true)} className="cursor-pointer">
  {share}
</div>}

           </div>

      {/* Data Rows */}
      <div className={`space-y-3 text-start ${view === 1 ? 'text-sm' : ''}`}>
        {patient_insights?.clinical_intel?.data_rows?.map((row, index) => (
          <div
            key={index}
            onClick={(e) => {
              e.stopPropagation();
              setLabel(row.test);
              setSelectedAlert(row);
            }}
            className={`flex justify-between items-start cursor-pointer p-2 rounded transition 
              ${view === 1 ? 'bg-gray-50 hover:bg-gray-100' : ''}`}
          >
            <div className="flex flex-col text-start flex-1">
              <span className={`font-semibold ${view === 1 ? 'text-sm' : 'text-[13px]'}`}>
                {row.test}
              </span>
              <span className={`${view === 1 ? 'text-xs' : 'text-[11px]'} text-gray-500`}>
                {row.result}
              </span>

              {/* Guideline Reference */}
              {row.guideline_reference && view === 1 && (
                <div>
                  📖{' '}
                  <a
                    href={row.guideline_reference.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 text-xs font-medium underline"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {row.guideline_reference.source}
                  </a>
                </div>
              )}

              {row.normal_range && (
                <span className={`${view === 1 ? 'text-[11px]' : 'text-[10px]'} text-gray-400`}>
                  Target: {row.normal_range}
                </span>
              )}
            </div>

            {/* Right Side Icons */}
            <div className="flex  items-end gap-1">
              {/* Status Chip */}
              <span
                className={`font-medium px-2 py-0.5 rounded-full whitespace-nowrap text-[10px] ${
                  row.status === 'high'
                    ? 'bg-rose-100 text-rose-600'
                    : row.status === 'low'
                    ? 'bg-orange-100 text-orange-600'
                    : 'bg-emerald-100 text-emerald-600'
                } ${view === 1 ? 'text-xs px-3 py-1' : ''}`}
              >
                {row.status}
              </span>

      {row?.source_node_id?.length > 0 && (
  <DescriptionOutlinedIcon
    fontSize={view === 1 ? 'small' : 'inherit'}
    sx={view === 0 ? { fontSize: 16 } : {}}
    className="text-blue-500 ml-2 cursor-pointer hover:text-blue-600"
    onClick={(e) => {
      e.stopPropagation();
      handleSummaryOpen(row);
    }}
  />
)}


            </div>
          </div>
        ))}
      </div>

  <PortalLabModalWrapper>

     <AlertDetailsModal
        view={view}
        isOpen={!!selectedAlert}
        label={label}
        onClose={() => {
          setLabel('');
          setSelectedAlert(null);
        }}
        alert={selectedAlert}
      />
  </PortalLabModalWrapper>
     

 
  <PortalLabModalWrapper>
    {loadingDetails ? (
      <div className="fixed inset-0 z-[9999] bg-black bg-opacity-50 flex items-center justify-center">
        <div className="bg-white rounded-lg p-6 shadow-lg flex flex-col items-center gap-2">
          <span className="text-gray-800 text-sm">Loading ...</span>
          <CircularProgress size={24} />
        </div>
      </div>
    ) : labsData ? (
      <FullScreenLabDetailsModal
        open={labsModal}
        onClose={() => {
          setLabsModal(false);
          setLabsData(null);
        }}
        data={labsData}
      />
    ) : null}
  </PortalLabModalWrapper>


<ClinicalShareModal
  open={shareModalOpen}
  onClose={() => setShareModalOpen(false)}
  data={patient_insights}
/>


 <SummaryModal
        open={openSummaryModal}
        onClose={() => {
          setOpenSummaryModal(false);
          setSummaryHtml("");
        }}
        htmlContent={
        loadingDetails? (
            `<div class="flex justify-center items-center h-40"><div class="text-center"><svg class="animate-spin h-6 w-6 text-blue-600 mx-auto" viewBox="0 0 24 24"></svg><p>Loading...</p></div></div>`
          ) : (
            summaryHtml
          )
        }
      />
{imageModalOpen && imagedata && (<FileViewerModal open={imageModalOpen} onClose={()=>{
  setImageData(null)
  setImageModalOpen(false)
}} data={imagedata}/>)}
      {/* {labsModal && !loadingDetails && labsData && (
        <FullScreenLabDetailsModal
          open={labsModal}
          onClose={() => {
            setLabsModal(false);
            setLabsData(null);
          }}
          data={labsData}
        />
      )} */}
    </div></div>
  );
};

export default ClinicalIntelligence;
